import { Dialog, Typography } from '@material-ui/core'
import * as React from 'react'

import ConnectionProblemIcon from 'assets/img/connection_problem_icon.png'
import { IOnlineProps } from 'components'

import './style.scss'

interface IOpen {
  open?: boolean
}
interface IProps extends IOnlineProps, IOpen {}

export const ConnectionProblemModal: React.FC<IProps> = ({
  online,
  open = true
}) => {
  const refOnline = React.useRef<boolean | null>(null)

  React.useEffect(() => {
    if (online === false) {
      refOnline.current = false
    }

    if (online && refOnline.current === false) {
      refOnline.current = true
      window.location.reload()
    }
  }, [online])

  return (
    <Dialog
      open={open}
      fullScreen={true}
      classes={{
        root: 'connection-problem-dialog',
        paper: 'connection-problem-dialog__paper'
      }}
    >
      <div className="connection-problem-dialog__wrap">
        <div className="connection-problem-dialog__top">
          <img
            src={ConnectionProblemIcon as string}
            className="connection-problem-dialog__icon"
            alt="connection-icon"
          />
          <Typography className="connection-problem-dialog__title title">
            Connection problem
          </Typography>
        </div>

        <p className="connection-problem-dialog__description">
          Fix your internet connection <br />
          and reload the page to continue
        </p>
        {/* <Button
      className="connection-problem-dialog__btn btn btn-cta btn-cta--primary "
      onClick={reloadPage}
    >
      Reload Page
    </Button> */}
      </div>
    </Dialog>
  )
}



// WEBPACK FOOTER //
// ./src/components/ConnectionProblemModal/index.tsx